module.exports = __webpack_public_path__ + "img/maldives.ccc4eba9.svg";